import React, { SFC } from 'react';
import SelectableRow from './selectable-row';
import Context from './selectable-list-context';

const SelectableList: SFC<any> = () => {
  return (
    <Context.Consumer>
      {({ list, handleSelect, isSelected, filter }) => (
        <>
          {list.map(item => (
            <SelectableRow
              key={item.id}
              item={item}
              disabled={false}
              handleSelect={handleSelect}
              isSelected={isSelected}
              filter={filter}
              depth={1}
            />
          ))}
        </>
      )}
    </Context.Consumer>
  );
};

export default SelectableList;
